export const paths = {
  CHAT: 'chat',
  SERVICEPOINT_MAP: 'servicepoint-locator',
}
